import * as React from 'react';
import { BaseSvg, SVGIconProps } from '../BaseSvg';
import { colorBlack } from '../../../../../theme/color';

export const XLogo: React.SFC<SVGIconProps> = ({ size = 22, color = colorBlack.toString(), ...props }) => (
  <BaseSvg width={size} height={size} viewBox="0 0 20 22" {...props}>
    <path
      d="M11.268 8.976l4.964-5.643h-1.176l-4.31 4.9-3.443-4.9H3.333l5.205 7.41-5.205 5.917h1.176l4.552-5.174 3.635 5.174h3.97l-5.398-7.684Zm-1.61 1.832-.528-.738L4.933 4.2H6.74l3.386 4.737.528.738 4.402 6.158H13.25l-3.592-5.025Z"
      fill={color}
    />
  </BaseSvg>
);
